import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React ,{Component} from 'react';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
let strCust=[{title:'Add Customer',year:'0',rowindex:'-1'}];

export default class AddUser extends Component {
constructor(props) {
    super(props);
	
	 this.state = {usid:'',us_id:0,open:false,data:[],redirect: false,details:'',btndisabled:false,submitbtn:"Submit",isactive:'',
userdata:[],logredirect:false,pagename:'',Role:"",rolelabel:'Select Role',name:"",emailid:"",phone:"",passwords:"",usercmpid:"",
code:'',exitpwd:'',PageData:[],Compid:'',cmpid:'',comprauto:[], selectedcompexchange:[],
submitbtn:"Submit",allchecked:false,  
      }
   
}





componentWillMount() {
  document.title = "User Management";

  if (localStorage.getItem("FMVid") === null) {
    this.setState({
      redirect: true,
      pagename: '/vendorlogin'
    });
  }

  let search = window.location.href;
  let Usid = this.getParameterByName('usid', search);

  if (Usid !== "" && Usid !== null) {
    this.Usergetgetdata(Usid);
  }
else{
  this.MasterPageApi();
}
}


	
	getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}	

Usergetgetdata(id) {
  axios.get(localStorage.getItem("ISIurl") + 'ajaxuser.php?action=getall&us_id=' + id)
    .then(resp => {  
      if (resp.data.length > 0) {
		  
		     const items = {
        title:resp.data[0].cmp_name,
          year:resp.data[0].us_cmp_id,
		 
           
        };
		
        this.setState({ 
          usid: resp.data[0].us_id,
          name: resp.data[0].us_firstname,
          names: resp.data[0].us_lastname,
          email: resp.data[0].us_emailid,
          phone: resp.data[0].us_phone,
          exitpwd: resp.data[0].us_password,
          code: resp.data[0].us_code,
          Role: resp.data[0].us_role,
          usercmpid: resp.data[0].us_cmp_id,
		  cmpid:resp.data[0].us_cmp_id,
		  selectedcompexchange:items
        }, () => {
          this.MasterPageApi();
        });
      } else {
        this.setState({  
          usid: 0,
          name: '',
          names: '',
          email: '',
          phone: '',
          exitpwd: '',
          passwords: '',
          code: '',
          Role: '',
          usercmpid: ''
        }, () => {
          this.MasterPageApi();
        }); 
      }
    })
}




onclickuserclose = (e) => {
	 this.setState({open:false});
	 
} 
myChangeHandler = (event) => {
 
   const re = /^[0-9\.]+$/;
  let nam = event.target.name;
  let val = event.target.value;
  if(nam==="phone")
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
  }
  }
  else{
	  
	   this.setState({[nam]: val});
  }
 
  
}
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }










  handleSubmit= (event) => {
	

    event.preventDefault();
	
	let name=this.state.name;
	let names=this.state.names;
	let email=this.state.email;
	let phone=this.state.phone;
	let passwords=this.state.passwords;
	let code=this.state.code;
	let Role=this.state.Role;
	let usercmpid=this.state.usercmpid;
	
	
	
	
	

 const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
if(name==="")
{
	this.setState({errormessage:"Please Enter First Name",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}
if(names==="")
{
	this.setState({errormessage:"Please Enter Last Name",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}

if(phone==="")
{
	this.setState({errormessage:"Please Enter Phone.",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}
if(email==="")
{
	this.setState({errormessage:"Please Enter Email.",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}else{
	
	 if (!remail.test(email)) {
	 this.setState({errormessage:"Please Enter Valid Email Id",erropen:true});		
	return false; 
	window.scrollTo({  top: 0,  behavior: 'smooth'});
  }
  
 if(passwords==="" && this.state.exitpwd==="")
{
	this.setState({errormessage:"Please Enter Password.",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}
 if(code==="")
{
	this.setState({errormessage:"Please Enter Code.",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}
 if(Role==="")
{
	this.setState({errormessage:"Please Select Role.",erropen:true});
	return false;
	window.scrollTo({  top: 0,  behavior: 'smooth'});
}


}

    let optionsVal=this.state.PageData;
	 let optionValues="";
      let sep1="";
	 
 optionsVal.forEach(eachval => {
     if(eachval.selected=="1")
	 {
		optionValues=optionValues+sep1+eachval.pm_id+"~"+eachval.selected;
		 sep1=";"
	 }
		   
	   });

this.setState({btndisabled:true,submitbtn:"Processing..."})
	 var formData = new FormData();

	  
	 if(this.state.usid!=="")
	 {
	  
	  formData.append('us_id',this.state.usid)
	 }else
	 {
		formData.append('us_id',0)  
	 }
	 formData.append('action','insertorupdate')
    formData.append('us_firstname',name)
	 formData.append('us_lastname',names)
	 formData.append('us_emailid',email)
	 formData.append('us_phone',phone)
	 formData.append('us_password',passwords)
	  formData.append('us_code',code)
	 formData.append('us_role',Role)
	
	 if(localStorage.getItem("ISIrole")!=="1")
{
		 formData.append('us_cmp_id',localStorage.getItem("ISIcmpid"))
}
else{
	
		 formData.append('us_cmp_id',this.state.cmpid)
}

	 formData.append('userid',localStorage.getItem("ISIuserid"))
	 formData.append('pages',optionValues)
	 
			
			
	
	  
	 axios.post(localStorage.getItem("ISIurl")+"ajaxuser.php", formData, {
        }).then(res => {
			
			if(res.data == -1)
{ 
		this.setState({errormessage:"User Already Exist.",erropen:true,btndisabled:false,
submitbtn:"Submit",
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	else if(res.data == -2)
{ 
		this.setState({errormessage:"Your Company has exceeded maximum members. Please contact admin",erropen:true,btndisabled:false,
submitbtn:"Submit",
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	else{
			this.setState({errormessage:"",erropen:false,open:false,btndisabled:false,logredirect:true, pagename:"/AdminUser",
submitbtn:"Submit",
		});
			
	}   
   });    
  };




MasterPageApi() {
  const usid = this.state.usid ? this.state.usid : 0;

  axios.get(localStorage.getItem("ISIurl") + 'ajaxpagemaster.php?action=getall&us_id=' + usid)
    .then(resp => {  
      if (resp.data.length > 0) {
        const updatedData = resp.data.map(item => ({
          ...item,
          access: item.selected === "1" ? 1 : 0
        }));
        this.setState({ PageData: updatedData }); 
      } else {
        this.setState({ PageData: [] });
      }
    });
}

	
	


HandleCheckbox = (pm_id) => {
  const updatedData = this.state.PageData.map(item => {
    if (item.pm_id === pm_id) {
      return {
        ...item,
        selected: item.selected === "1" ? "0" : "1",
        access: item.selected === "1" ? 0 : 1
      };
    }
    return item;
  });

  this.setState({ PageData: updatedData }, () => {
    console.log("Updated PageData:", this.state.PageData);
  });
};

	onInputcompChange = (event, newTextValue) => {
	if(newTextValue!==" "){
	  this.setState({Compid:newTextValue})
	} 
}

onTagscompexchange = (event, values) => {
	if(values!==" " && values!==null && values.rowindex!="-1"){
		this.setState({
		Compid:values.year,
		 cmpid:values.year,
		selectedcompexchange:values})
		
	}
	
	else
	{
		 this.setState({ Compid:'',cmpid:'',selectedcompexchange:[]})
	}
	
}
onloadCompBind=(event)=>{

	 if(event.target.value.length>0 )
	{
	 axios.get(localStorage.getItem("ISIurl")+'ajaxcompany.php?action=CompAuto&cmp_name='+event.target.value)
  .then(resp => { 
  

	 var rowsArray = resp.data;
	 rowsArray.map((row, i) => {
			 
		 const items = {
        title:row.title,
          year:row.year,
		  cmpid:row.year,		  
		  rowindex:row.rowindex,
           
        };
		
		 const cusfound = strCust.some(el => el.year === row.year);
		 if (!cusfound) strCust.push(items)
		  
		 });
	 strCust = strCust.sort((a, b) => a.rowindex < b.rowindex ? 1 : -1)
		  this.setState({comprauto:strCust},
		  
		  ()=>{})
  });
	 
	}
}

HandleAllcheckbox=()=>{
                
           this.setState({iconslist:true});
          
          
        
         var studArray = this.state.PageData;
         
         const updatedArray = [...this.state.PageData];
         
       
         
         this.setState({allchecked:!this.state.allchecked},() => {
             if(this.state.allchecked===false)
                 {
                        
                 var subnewRow=studArray.map((rowssub,j) => {
                                         updatedArray[j].selected = "0" ;
                                 });
                                
                                         
                           
                                 
                                 
                  }
                 else if(this.state.allchecked===true)
                         
                         {
                                
                                  var subnewRow = studArray.map((rowssub, j) => {
                                   updatedArray[j].selected = "1" ;
                           });
                                 
                         }
                         
                        this.setState({PageData:updatedArray,},()=>{
                                   
                     
                  
                  
              
               
                
                  
  

                        });
                 
         }); 
         
         
  } 
  
render() {
  if (this.state.logredirect === true) {
    return <Navigate to={this.state.pagename} />;
  }

  return (
    <React.Fragment>
     
    
    <p style={{textAlign:'right'}}>
	<a href="#/Adminuser" >
		<Button variant="contained"  className="frmSecondarybtn" >
			 Back
		</Button></a>
       
	
	</p>
     
          <p>
            <Collapse in={this.state.erropen}>
              <Alert
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => this.handleErrorclose()}
                  >
                    {/* Close button content */}
                  </IconButton>
                }
                severity="error"
              >
                {this.state.errormessage}
              </Alert>
            </Collapse>
          </p>

          <div className="customerform">
            <ul>
              <li>
                <p>First Name <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="name"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.name}
                    inputProps={{ tabIndex: "1", maxLength: 150 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
              </li>

              <li>
                <p>Last Name <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="names"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.names}
                    inputProps={{ tabIndex: "2", maxLength: 150 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
              </li>

              <li>
                <p>Email: <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="email"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.email}
                    inputProps={{ tabIndex: "3", maxLength: 150 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
              </li>

              <li>
                <p>Phone No: <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="phone"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.phone}
                    inputProps={{ tabIndex: "4", maxLength: 15 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
              </li>

              <li>
                <p>Password <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="passwords"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.passwords}
                    type="Password"
                    inputProps={{ tabIndex: "5", maxLength: 50 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
              </li>

              <li>
                <p>Code <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="code"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.code}
                    type="Code"
                    inputProps={{ tabIndex: "6", maxLength: 10 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
              </li>

              <li>
                <p><span className="validation">*</span> Role</p>
                <p>
                  <FormControl className="stadrp">
                    <Select
                      native
                      variant="outlined"
                      margin="normal" value={this.state.Role}
                      onChange={this.myChangeHandler}
                      id="type"
                      inputProps={{ tabIndex: "7" }}
                      className="txtbox"
                      name="Role"
                    >
                      <option value="">Select Role</option>
                      <option value={2}>Admin</option>
                      <option value={3}>Manager</option>
                      <option value={4}>Sales</option>
                    </Select>
                  </FormControl>
                </p>
              </li>
			  {localStorage.getItem("ISIrole")==="1" && (
			 <li style={{"width":"20%"}}>
			  <p><span className="validation">*</span>Company</p>
		<p>
			<Autocomplete
			  id="free-solo-demo"
			  
			  className="txtbox"  inputValue={this.state.Compid}
			  options={this.state.comprauto}   onInputChange={this.onInputcompChange}
			   onChange={this.onTagscompexchange} 
				value={this.state.selectedcompexchange}
			  renderInput={(params) => (
				<TextField {...params} className="txtbox" onChange={this.onloadCompBind}  variant="outlined" />
			  )}
		 getOptionLabel={(option) => option.title || ""}

        renderOption={(props, option: AcOption) => (
        <React.Fragment>
          <table width='200%' >
          
            <tbody> {option.rowindex!=="-1" &&(
              <tr {...props}>
                <td width='10%'>{option.title}</td>
         
				
              </tr> )}
			  
			  
            </tbody>
          </table>
        </React.Fragment>
      )}
    />
	
	
	
	</p>
			  
			  </li>
			 )}
            </ul>
          </div>


		<div className="userpageaccessbox">
				  <h3 className="page-heading">Page Access</h3>
				  
				  <table className="gtable" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
					<thead>
					  <tr style={{ backgroundColor: '#f0f0f0', textAlign: 'left' }}>
						<th style={{ padding: '10px', width: '30%' }}>Page Name</th>
						<th style={{ padding: '10px', width: '30%' }}><Checkbox 
           checked={this.state.allchecked}
           onChange={()=>{this.HandleAllcheckbox()}}
            inputProps={{ 'aria-label': 'controlled' }}
            sx={{
          color: 'Black', 
         '&.Mui-checked': {
            color: 'Black', 
        },
        
        
    }}
              /> 	Access</th>
					  </tr>
					</thead>
					<tbody>
					  {this.state.PageData && this.state.PageData.length > 0 ? (
						this.state.PageData.map((item, index) => {
						  const isChecked = item.access === 1; 
						  return (
							<tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
								<td style={{ padding: '2px',textAlign:'left' }}>{item.pm_name}</td>
							  <td style={{ padding: '2px', textAlign: 'left' }}>
								<Checkbox
								  checked={item.selected === "1"} 
								  onChange={() => this.HandleCheckbox(item.pm_id)}
								/>


							  </td>
							</tr>
						  );
						})
					  ) : (
						<tr>
						  <td colSpan={2} style={{ padding: '8px', textAlign: 'center' }}>
							No Pages Available
						  </td>
						</tr>
					  )}
					</tbody>
				  </table>
		</div>




<div className="savebtn">
	

<Button variant="contained" disabled={this.state.btndisabled} className="frmSecondarybtn" onClick={this.handleSubmit}>
    {this.state.submitbtn}
</Button>
       


 </div>     
    
    </React.Fragment>
  );
}
}